import { RouterProvider } from 'react-router-dom';

// project imports
import router from 'routes';
import ThemeCustomization from 'themes';

import ScrollTop from 'components/ScrollTop';

// ==============================|| APP - THEME, ROUTER, LOCAL ||============================== //
import { UserProvider } from './contexts/UserContext';

export default function App() {
  return (
      <UserProvider>
          <ThemeCustomization>
              <ScrollTop>
                <RouterProvider router={router} />
              </ScrollTop>
            </ThemeCustomization>
      </UserProvider>
 
  );
}
